module.exports = __webpack_public_path__ + "img/SuperGoatLifeBat.7ca24717.png";